<template>
    <TraiterDemandeInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import TraiterDemandeInscription from "@/components/DemandeInscription/TraiterDemandeInscription.vue";

    export default defineComponent({
      name: "TraiterDemandeInscriptionPage",
      components: {
        
        TraiterDemandeInscription,
      },
    });
  </script>